"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var LineGraphIcon = /*#__PURE__*/(0, _react.forwardRef)(function (props, ref) {
  return /*#__PURE__*/_react["default"].createElement(_core.SvgIcon, _extends({}, props, {
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.879 10.25l7.049-6.394a1.254 1.254 0 011.73.042 1.13 1.13 0 01-.046 1.641l-7.075 6.33a2.53 2.53 0 01-3.556.02L8.783 9.744 4.127 14.47a1.24 1.24 0 01-1.76.006 1.26 1.26 0 01-.008-1.774l4.619-4.689c.239-.242.515-.425.81-.548a2.53 2.53 0 012.768.514l2.323 2.27zM2 19h20a1 1 0 010 2H2a1 1 0 010-2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.666 16.95c-.18.033-.402.05-.666.05-1.655 0-2.652-.18-2.993-.542a1.268 1.268 0 01-.068-.064L2.384 9.84a1.25 1.25 0 111.768-1.767l6.555 6.555c.024.023.046.048.068.073h10.1a1.125 1.125 0 010 2.25h-8.21z",
    opacity: ".6"
  })));
});
LineGraphIcon.category = 'Graph';
var _default = LineGraphIcon;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@mineral/icons/build/LineGraphIcon.js
// module id = 1105
// module chunks = 0